export enum FileClaimSubStep {
    landingPage = 'landing',
    AgreementNumberPage = 'agreementNumber',
    AgreementGridPage = 'agreementGrid'
}
